<script setup>
import { useMainStore } from '@/stores/store.js';
import BaseModalDialog from './utils/BaseModalDialog.vue';

const store = useMainStore();

const props = defineProps({
    fnCancelModal: {
        type: Function,
        required: true,
    },
});
</script>

<template>
    <BaseModalDialog :on-close="fnCancelModal" :show-backdrop="false">
        <div class="text-md font-bold sm:text-lg">
            {{
                store.overlays.reporterror.message ||
                'Oops! We encountered an unexpected issue while generating your report. Please click/tap OK to try again. Thank you for your patience!'
            }}
        </div>
        <button
            type="button"
            class="lux-btn lux-btn-black mt-5 w-auto bg-black text-white"
            @click="fnCancelModal()">
            Ok
        </button>
    </BaseModalDialog>
</template>
